import { render, staticRenderFns } from "./convert-uid-to-phone.vue?vue&type=template&id=5e227bec&"
import script from "./convert-uid-to-phone.vue?vue&type=script&lang=js&"
export * from "./convert-uid-to-phone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports